import { useEffect } from 'react'
import { App as CapacitorApp, AppState } from '@capacitor/app'
import sessionResumeService from '../../resume/service/sessionResume.service'

export const useAppForegroundHandler = () => {
  useEffect(() => {
    let listener: { remove: () => void } | null = null

    const handleAppStateChange = async (state: AppState) => {
      if (state.isActive) {
        sessionResumeService.handleForeground()
      }
    }

    CapacitorApp.addListener('appStateChange', handleAppStateChange).then((l) => {
      listener = l
    })

    return () => {
      listener?.remove()
    }
  }, [])
}
